function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "path-1",
  points: "0.00716834171 0.108495 17.2010126 0.108495 17.2010126 17.775 0.00716834171 17.775"
}), React.createElement("polygon", {
  id: "path-3",
  points: "0.0623894472 0.108495 17.2562337 0.108495 17.2562337 17.775 0.0623894472 17.775"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo_rodeo",
  stroke: "none",
  strokeWidth: 1,
  fill: "#fff",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "HOME-Copy-2",
  transform: "translate(-20.000000, -22.000000)"
}, React.createElement("g", {
  id: "Logo",
  transform: "translate(20.000000, 22.000000)"
}, React.createElement("g", {
  id: "Group-13"
}, React.createElement("path", {
  d: "M8.89984673,8.434935 C11.4270829,8.434935 12.5502739,7.36056 12.5502739,5.576535 C12.5502739,3.771135 11.383892,2.696535 8.79175628,2.696535 L2.24640452,2.696535 L2.24640452,8.434935 L8.89984673,8.434935 Z M2.26130653e-05,0.568935 L9.22389196,0.568935 C12.960701,0.568935 14.9047462,2.41731 14.9047462,5.512185 C14.9047462,7.467885 13.8894196,9.01521 12.2262286,9.595485 C13.5656005,9.93951 14.2351734,10.734885 14.4728367,12.432735 C14.8400729,14.839785 14.5592186,16.04331 15.1424095,17.37576 L15.1424095,17.547885 L12.8311281,17.547885 C12.3775101,16.537635 12.4424095,14.904135 12.2262286,13.206285 C11.923892,10.863585 11.4270829,10.45521 8.89984673,10.45521 L2.24640452,10.45521 L2.24640452,17.547885 L2.26130653e-05,17.547885 L2.26130653e-05,0.568935 Z",
  id: "Fill-1",
  fill: "#fff"
}), React.createElement("g", {
  id: "Group-5",
  transform: "translate(16.959799, 0.116685)"
}, React.createElement("path", {
  d: "M14.8250578,8.74827 C14.8250578,4.944195 12.3410126,2.236095 8.66887688,2.236095 C4.93206784,2.236095 2.38312312,4.944195 2.38312312,8.74827 C2.38312312,12.78882 4.93206784,15.64722 8.66887688,15.64722 C12.3410126,15.64722 14.8250578,12.78882 14.8250578,8.74827 M0.00716834171,8.85582 C0.00716834171,3.740445 3.54973116,0.108495 8.66887688,0.108495 C13.7233492,0.108495 17.2010126,3.740445 17.2010126,8.85582 C17.2010126,14.078295 13.7233492,17.775045 8.66887688,17.775045 C3.54973116,17.775045 0.00716834171,14.078295 0.00716834171,8.85582",
  id: "Fill-3",
  fill: "#fff",
  mask: "url(#mask-2)"
})), React.createElement("path", {
  d: "M44.0311432,15.505965 C48.027098,15.505965 50.4032789,13.098915 50.4032789,9.01539 C50.4032789,4.996215 48.027098,2.61054 44.0311432,2.61054 L39.4734799,2.61054 L39.4734799,15.505965 L44.0311432,15.505965 Z M37.227098,0.56889 L44.0311432,0.56889 C49.3664698,0.56889 52.7577513,3.685365 52.7577513,9.036765 C52.7577513,14.32404 49.2800879,17.54784 44.0311432,17.54784 L37.227098,17.54784 L37.227098,0.56889 Z",
  id: "Fill-6",
  fill: "#fff"
}), React.createElement("polygon", {
  id: "Fill-8",
  fill: "#fff",
  points: "55.8238342 0.5689575 70.1453668 0.5689575 70.1453668 2.6965575 58.0704422 2.6965575 58.0704422 7.8546825 69.3894121 7.8546825 69.3894121 9.9393075 58.0704422 9.9393075 58.0704422 15.4200825 70.2534573 15.4200825 70.2534573 17.5479075 55.8238342 17.5479075"
}), React.createElement("g", {
  id: "Group-12",
  transform: "translate(72.587940, 0.116685)"
}, React.createElement("path", {
  d: "M14.8802789,8.74827 C14.8802789,4.944195 12.3962337,2.236095 8.72409799,2.236095 C4.98728894,2.236095 2.43834422,4.944195 2.43834422,8.74827 C2.43834422,12.78882 4.98728894,15.64722 8.72409799,15.64722 C12.3962337,15.64722 14.8802789,12.78882 14.8802789,8.74827 M0.0623894472,8.85582 C0.0623894472,3.740445 3.60495226,0.108495 8.72409799,0.108495 C13.7785704,0.108495 17.2562337,3.740445 17.2562337,8.85582 C17.2562337,14.078295 13.7785704,17.775045 8.72409799,17.775045 C3.60495226,17.775045 0.0623894472,14.078295 0.0623894472,8.85582",
  id: "Fill-10",
  fill: "#fff",
  mask: "url(#mask-4)"
}))))));

var SvgLogoRodeo = function SvgLogoRodeo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "90px",
    height: "18px",
    viewBox: "0 0 90 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoRodeo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_rodeo.3a932a2f.svg";
export { ForwardRef as ReactComponent };